import moment from "moment/moment";
import { useState, useEffect, useReducer } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../../layout/MainArea";
import { requestToServer } from "../../../utils/appUtils";
// import { reducerModalWindow } from "./ModalMfS";
import { reducerModalWindow, ModalMfS } from "./ModalMfS";
import { GetConnERA, PostConnERA, PostControlMC } from "../../../../api";
import { Modal } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


function ERAStations(props) {
    clearInterval(window.timer)
    const token = localStorage.getItem('token')
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(3);
    const [date, setDate] = useState();
    const [loadingStatus, setLoadingStatus] = useState(true)
    const [paramsModalWindow, dispatchModalWindow] = useReducer(reducerModalWindow, { show: false});
    const [activeIndex, setActiveIndex] = useState(0)
    const [showParrot, setShowParrot] = useState(false)
    const [inputParrot, setInputParrot] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [arrTable, setArrTable] = useState([])



    let services = [
        { id: 0, name: "Доступность ККС", status: status, date: date, href: 'msdata' },
    ];

    const handleModal = (id) => {
        dispatchModalWindow({ type: 'def', id: id });
    };

const handleClick = (event) => {
    if (loading) return;
   event && event.preventDefault();
   event && event.target.blur();
    //    refreshData();
    setLoading(true);
    GetConnERA(token).then((e) => {
      setArrTable([{address: e.data.address, name: "Адрес"}])
      setServerData(true)
    })
    setDate(Date.now())
    setTimeout(() => {
      setLoading(false);
    }, 650);
}


    

    useEffect(() => {
      handleClick()
      
    }, [])

    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    const handleCloseParrot = (event) => {
        setShowParrot(false);
        setInputParrot();
    }
    const handleBlur = () => {
        // При потере фокуса устанавливаем 0 если поле пустое
        if (inputParrot === '') {
            setInputParrot();
        }
    };

       const handleAcceptParrot = (id) => {
            setLoading(true);
            let forSend = { address: inputParrot }
            PostConnERA(token, forSend).then((e) => {
                setLoading(false);
                setShowParrot(false);
                setInputParrot();
            })
        }

        const handleChange = (e) => {
            const inputValue = e.target.value;
            
            // Разрешаем пустую строку для UX
            if (inputValue === '') {
                setInputParrot('');
              return;
            }
             setInputParrot(e.target.value.replace(/[^a-zA-Z0-9.\-]/g, ''));
        };

    if (!arrTable.length)
        return <MainArea loading />;

    return (
        <>
            <MainArea>
                    <div className={classCard} style={styleCard}>
                        <MainAreaHeader caption="ЭРА" />
                        <div className="container-fluid px-3 py-4 dashboard">
                        <div className="row g-3">  
                              <div className="cont-table">
                                                    <DataTable removableSort emptyMessage="Нет данных" value={arrTable} tableStyle={{ minWidth: '50rem' }}>
                                                        {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                                        <Column field="name" sortable header="Параметр"></Column>
                                                        <Column field="address" sortable header="Значение"></Column>
                                                    </DataTable>
                                                </div>
                                                </div></div>
                                {services.map((e, i) => {
                                return (
                                    <div key={i} className="container-fluid padding-f-d dashboard">

                                        <fieldset className="mfuncbutton-fieldset padding-f">
                                            <div className="cont-mfuncbuttons">
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => {setShowParrot(true); setInputParrot(arrTable[0]?.address)}} >Изменить параметры</button></div>
                                                }
                                            </div>
                                         </fieldset>
                                        <Modal show={showParrot} className={`modal-parrot`} onHide={handleCloseParrot}
                                            // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
                                            onExited={() => setShowParrot(false)} centered backdrop="static">
                                            <Modal.Header closeButton>
                                                <Modal.Title className="h6">Изменить параметры</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body className="pb1-1">
                                        {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                                <fieldset className="mfuncbutton-fieldset">
                                                    <input onBlur={handleBlur} value={inputParrot} className='input-parrot' onChange={handleChange}></input>
                                                </fieldset>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                                <fieldset>
                                                    <div className='cont-btn'>
                                                        <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseParrot}>Закрыть</button>
                                                        <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={() => handleAcceptParrot(i)}>Применить</button>
                                                    </div>
                                                </fieldset>
                                            </Modal.Footer>
                                        </Modal >
                                    </div>
                                )
                            })}
                    </div>
  
                {/* </MainAreaBody> */}
            </MainArea >
        </>
    );
}



export default ERAStations;
